@if (auth.canAccessPropertyListings() || isUnlocked) {
  <app-view-area [selectedItem]="selectedItem" [isMobileFullView]="isMobileFullView"
    [propertyAccessGranted]="isUnlocked" [activeTab]="activeTab" (activeTabChange)="activeTab = $event; activeTabChange.emit($event)" (lightboxOpen)="lightboxOpen.emit($event)" />
} @else {
<section 
  *ngIf="selectedItem as item"
  class="w-full sticky top-0 z-[2] bg-white border-b border-gray-200"
>
  <div class="max-w-7xl mx-auto px-4 py-2 flex flex-row items-center justify-between gap-2">

    <!-- Top Row (Dots + Text) -->
    <div class="flex items-center gap-2 text-sm">

      <!-- Dots -->
      <div class="flex py-2 rounded-sm bg-gray-100 px-2 border border-gray-200 items-center gap-1 shrink-0">
        <ng-container *ngFor="let i of [].constructor(freeCreadits); let idx = index">
          <span 
            class="w-2 h-2 rounded-full"
            [ngClass]="{
              'bg-gray-300': idx >= viewCount,
              'bg-black': idx < viewCount && viewCount < freeCreadits - 1,
              'bg-orange-400': idx < viewCount && (freeCreadits - viewCount) === 1,
              'bg-red-500': viewCount >= freeCreadits
            }"
          ></span>
        </ng-container>
      </div>

      <!-- Text -->
      <div class="text-gray-700 flex flex-col sm:flex-row leading-tight">
        <span class="font-medium text-black mr-1">
          {{ viewCount >= freeCreadits ? 0 : freeCreadits - viewCount }} views left
        </span>

        <span 
          *ngIf="viewCount >= freeCreadits" 
          class="text-red-500 "
        >
          (Limit reached)
        </span>
      </div>
    </div>

    <!-- CTA -->
    <div class="flex justify-start sm:justify-start">
      <a 
        *ngIf="viewCount >= freeCreadits || (freeCreadits - viewCount) <= 1"
        routerLink="/payment"
        class="text-sm font-medium text-[#8b5cf6] hover:underline"
      >
        Unlock All →
      </a>
    </div>

  </div>
</section>

<main class="flex-1 overflow-y-auto bg-white " *ngIf="selectedItem">
  <div class="p-4 sm:pb-8 mx-auto">
    <div class=" p-4 rounded-2xl border border-gray-200 box-shadow-ff">
      
      <div class="basic-property-header flex flex-col sm:flex-row justify-between items-start gap-6 mb-6">
        <div class="flex flex-col min-w-0 flex-1">
          <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 mb-2 break-words">{{(selectedItem?.name | titlecase)}}
                  <!-- ({{selectedItem?()?.microMarket?.cluster}}) -->
                  
          </h1>

          <div class="flex flex-col gap-1">
            <div class="flex flex-col sm:flex-row sm:items-center mb-4 gap-3">
                <span class="text-xl font-medium text-gray-800" *ngIf="getPriceRange() as range">
                    {{ range.min | inrShort }} 
                    <ng-container *ngIf="!range.isSame">
                        <span class="text-gray-400 font-light mx-1">-</span>
                        {{ range.max | inrShort }}
                    </ng-container>
                </span> <span class="hidden sm:flex">|</span>
                <p class=" font-medium text-gray-500">{{selectedItem?.microMarket?.micromarketName}}</p>
            </div>
            <div class="flex flex-wrap gap-2 mb-4 sm:mb-0 items-center">
              <span *ngFor="let item of selectedItem?.price" class="text-[10px] font-bold text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded border border-indigo-100">
                {{ item.bhkType }}
              </span>
              <!-- <span class="inline-flex items-center rounded-sm bg-[#EFEFEF] px-2 py-1 text-xs font-normal text-black gap-2">
                <i class="fa fa-tag text-gray-500"></i> Luxury
              </span> -->
              <span class="inline-flex items-center rounded-sm bg-[#EFEFEF] px-2 py-1 text-xs font-normal text-black gap-2">
                <i class="fa fa-wrench text-gray-500"></i>{{selectedItem?.possession}}
              </span>
              @if (hasAmenity(selectedItem?.amenities, 'private_terrace')) {
                <div class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
                  
                  <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path [attr.d]="AMENITY_MAP['private_terrace'].icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <span class="text-xs font-bold">
                    {{ AMENITY_MAP['private_terrace'].label }}
                  </span>

                </div>
              }
              @if (hasAmenity(selectedItem?.amenities, 'private_garage')) {
                <div class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
                  
                  <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path [attr.d]="AMENITY_MAP['private_garage'].icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <span class="text-xs font-bold">
                    {{ AMENITY_MAP['private_garage'].label }}
                  </span>

                </div>
              }
              @if (hasAmenity(selectedItem?.amenities, 'private_jacuzzi')) {
                <div class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
                  
                  <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path [attr.d]="AMENITY_MAP['private_jacuzzi'].icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <span class="text-xs font-bold">
                    {{ AMENITY_MAP['private_jacuzzi'].label }}
                  </span>

                </div>
              }
            </div>
          </div>
        </div>
        <div class="flex sm:flex-col shrink-0 items-center justify-between sm:justify-center gap-3
            sm:justify-end sm:gap-4
            fixed sm:relative bottom-0 left-0 right-0
            sm:bottom-auto sm:left-auto sm:right-auto
            bg-white/60 backdrop-blur-md sm:bg-transparent
            px-4 py-3 sm:p-0
            border-t sm:border-0 border-gray-200
            z-50">

            <!-- MOBILE: DATE -->
            <span class="flex flex-col text-[11px] text-black sm:hidden">
              Last updated:
              <span class="text-[14px]">
                {{selectedItem.updatedAt | date:'dd MMM yyyy'}}
              </span>
            </span>

            <!-- RIGHT ACTIONS -->
            <div class="flex items-center gap-3 sm:gap-4 ml-auto">

              <!-- FAV -->
              
              <button
                (click)="toggleFav(selectedItem._id)"
                [disabled]="togglingFavId === selectedItem._id"
                class="group relative w-10 h-10 flex items-center justify-center rounded-full
                      transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed
                      sm:hover:bg-gray-100 sm:hover:scale-110"
                [ngClass]="_PS.isFav(selectedItem._id) ? 'text-red-500' : 'text-gray-300'"
              >

                <!-- Spinner -->
                <svg *ngIf="togglingFavId === selectedItem._id"
                  class="w-6 h-6 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                </svg>

                <!-- Filled -->
                <svg *ngIf="togglingFavId !== selectedItem._id && _PS.isFav(selectedItem._id)"
                  class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"/>
                </svg>

                <!-- Outline -->
                <svg *ngIf="togglingFavId !== selectedItem._id && !_PS.isFav(selectedItem._id)"
                  class="w-6 h-6 group-hover:text-red-400 transition"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-width="2"
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                </svg>

              </button>
              <span class="ml-2 rounded-full border px-3 py-1 text-xs" *ngIf="backendBadgeLabel(selectedItem.isPropertyVerified, 'Legal Verified') as legalLabel">{{ legalLabel }}</span>
              <!-- PRIMARY CTA LOGIC -->

              <!-- 1. BEFORE LIMIT -->
              <button
                *ngIf="!isUnlocked && viewCount < maxFreeViews"
                (click)="handleViewClick(selectedItem._id)"
                [disabled]="isLoading || !viewStatusReady"
                class="bg-black text-white
                      px-5 py-3 sm:px-6 sm:py-3
                      rounded-xl sm:rounded-full
                      shadow-lg sm:shadow-none
                      flex items-center justify-center
                      min-w-[160px]"
              >
                <span *ngIf="!isLoading">
                  View Details ({{ maxFreeViews - viewCount }} left)
                </span>

                <span *ngIf="isLoading" class="flex items-center gap-2">
                  <svg class="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24"></svg>
                  Processing...
                </span>
              </button>

              <!-- 2. LIMIT REACHED -->
              <button
                *ngIf="!isUnlocked && viewCount >= maxFreeViews"
                (click)="openUpgradeModal()"
                class="bg-red-600 text-white
                      px-5 py-3 sm:px-6 sm:py-3
                      rounded-xl sm:rounded-full
                      shadow-lg sm:shadow-none
                      min-w-[160px]"
              >
                Unlock Full Details
              </button>

              <!-- 3. UNLOCKED -->
              <button 
                *ngIf="isUnlocked"
                (click)="propertyRequest(selectedItem._id)" 
                [disabled]="isLoading"
                class="bg-black text-white
                      px-5 py-3 sm:px-6 sm:py-3
                      rounded-xl sm:rounded-full
                      shadow-lg sm:shadow-none
                      min-w-[160px]"
              >
                <span *ngIf="!isLoading">Contact Advisor</span>

                <span *ngIf="isLoading" class="flex items-center gap-2">
                  <svg class="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24"></svg>
                  Processing...
                </span>
              </button>

            </div>

            <!-- DESKTOP DATE -->
            <span class="hidden sm:block text-[12px] text-gray-500 ml-4">
              Last updated: {{selectedItem.updatedAt | date:'dd MMM yyyy'}}
            </span>

          </div>
      </div>

      <section class="basic-tabs-surface">
        <app-property-tabs [activeTab]="activeTab" (activeTabChange)="activeTab = $event; activeTabChange.emit($event)" />
      </section>
      <section class="basic-tab-content">
      @if (activeTab === 'property') {
      <div [ngClass]="{'blur-sm pointer-events-none': !isUnlocked}" class="transition-all duration-300">
        <app-gallery
          class="property-gallery" [ngClass]="{'pointer-events-none': !isUnlocked}"
          [images]="formattedGalleryImages"
          (lightboxOpen)="lightboxOpen.emit($event)">
        </app-gallery>
        
        <div class="my-4">
          <span class="px-3 py-1 rounded-full text-[11px] font-medium
                  bg-[#FFF8E7] text-[#B76E00] border border-[#E6C56A]" *ngIf="backendBadgeLabel(selectedItem.isExclusive, 'Exclusive') as exclusiveLabel">
            {{ exclusiveLabel }}
          </span>


          <span class="px-3 py-1 rounded-full text-[11px] font-medium
                  bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF]" *ngIf="backendBadgeLabel(selectedItem.isHighDemand, 'High Demand') as demandLabel">
            {{ demandLabel }}
          </span>


          <span class="px-3 py-1 rounded-full text-[11px] font-medium
                  bg-[#F5F3FF] text-[#6D28D9] border border-[#C4B5FD]" *ngIf="backendBadgeLabel(selectedItem.isInvestmentGrade, 'Investment Grade') as investmentLabel">
            {{ investmentLabel }}
          </span>
        </div>
        
        <div class="my-8">
          <h3 class="font-semibold text-md mb-1">About the project</h3>
          <div class="relative overflow-hidden transition-all duration-300"
            [ngClass]="isDescriptionExpanded ? 'max-h-[1000px]' : 'max-h-[80px]'">

            <p class="text-sm text-gray-500 leading-relaxed">
              {{ selectedItem?.description }}
            </p>

            <!-- Fade Effect -->
            <div
              *ngIf="!isDescriptionExpanded"
              class="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent">
            </div>

          </div>

          <button
            *ngIf="selectedItem?.description?.length > 300"
            type="button"
            (click)="isDescriptionExpanded = !isDescriptionExpanded"
            class="mt-3 text-sm font-medium text-gray-400 hover:underline hover:text-black">

            {{ isDescriptionExpanded ? 'See Less' : 'See More' }}

          </button>
        </div>
        <div class="flex flex-col sm:flex-row gap-4 pb-4 sm:flex-wrap">
          <span class="text-sm box-shadow-ff p-2 rounded-sm"> 
            Community Category : <span class="underline-offset-4 font-bold decoration-gray-400">{{ selectedItem?.communityCategory }} </span> 
          </span>
          <span class="text-sm box-shadow-ff p-2 rounded-sm"> 
            Seller Profile : <span class="underline-offset-4 font-bold decoration-gray-400">{{ selectedItem?.sellerProfile }} </span> 
          </span>
          <span *ngIf="selectedItem?.builder" class="text-sm box-shadow-ff p-2 rounded-sm">
            Builder Name :
            <span class="underline-offset-4 font-bold decoration-gray-400">
              {{ selectedItem?.builder }}
            </span>
          </span>
        </div>
      </div>

      <div [ngClass]="{'hidden': !isUnlocked}" id="hid_basic">
        <div class="flex flex-wrap gap-3 pb-1 mb-8 border-b border-gray-200 ">
          @if (getPrices().length) {

            <div class="grid grid-cols-1 w-full md:grid-cols-3 gap-4 py-4">

              @for (item of getPrices(); track item._id) {

                <div class="p-3 flex-1 w-full rounded-xl box-shadow-ff bg-white">

                  <!-- BHK -->
                  <div class="text-lg font-bold text-indigo-600 mb-2">
                    {{ item.bhkType | uppercase}} {{ item.propertyStructureType }}
                  </div>

                  <!-- Area -->
                  <div class="flex gap-4 w-full justify-between items-center">
                    <div class="flex text-sm flex-col w-full text-gray-600 p-2 bg-gray-50 rounded-sm border-1 border-gray-100">
                      Area: 
                      <span class="font-semibold text-gray-900">
                        {{ item.areaInSq | numberFormat  }} sq.ft
                      </span>
                    </div>

                    <!-- Price -->
                    <div (click)="togglePrice()" 
                        class="flex text-sm flex-col w-full text-gray-600 p-2 bg-gray-50 rounded-sm border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors">
                      Price:
                      <span class="font-semibold text-gray-900 whitespace-nowrap">
                        <ng-container *ngIf="showFullPrice; else shortPrice">
                          ₹{{ item.price | numberFormat }}
                        </ng-container>
                        <ng-template #shortPrice>
                          {{ item.price | inrShort }}
                        </ng-template>
                      </span>
                    </div>

                    <!-- Avg price -->
                    <!-- <div class="flex text-sm flex-col w-full text-gray-600 p-2 bg-gray-50 rounded-sm border-1 border-gray-100">
                      Avg Price:
                      <span class="font-semibold text-gray-900">
                        ₹ {{ item.averagePrice | number:'1.0-0' }} / sq.ft
                      </span>
                    </div> -->
                  </div>

                </div>

              }

            </div>

          }
        </div>
        <div class="mb-8">
          <div class="flex justify-between grid sm:grid-cols-2 items-start gap-4">
            <div class="flex flex-col w-[1/2] gap-6">
              <div class="flex flex-col mb-4">
                <p class="text-[12px] font-semibold text-gray-800 uppercase tracking-wider w-full md:w-auto mb-2">
                    Nearby Places:
                </p>
                <!-- <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke-width="2" />
                    </svg>
                    <span class="text-[11px] font-bold">School</span> -->
                <div class="flex flex-wrap gap-3 ">
                  <div *ngFor="let item of asArray(selectedItem?.nearbyPlaces)" 
                    class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100">
                    <span class="h-1 w-1 rounded-full bg-emerald-300"></span>
                    <span class="text-[11px] font-extrabold text-emerald-900">{{ item }}</span>
                  </div>
                  
                </div>
              </div>
              <div class="flex flex-col">
                <p class="text-[12px] font-semibold text-gray-800 uppercase tracking-wider w-full md:w-auto mb-4">
                    Living Environment:
                </p>
                <div class="flex flex-wrap gap-3 ">
                  <div *ngFor="let item of asArray(selectedItem?.livingEnvironment)" 
                    class="flex items-center gap-2 px-3 py-1.5 rounded-sm box-shadow-ff border border-emerald-100">
                    <span class="text-[11px] font-extrabold">{{ item }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-col w-[1/2] gap-6">
              <div class="flex flex-col">
                  <p class="text-[12px] font-semibold text-gray-800 uppercase tracking-wider w-full md:w-auto mb-4">Location :</p>
                  <p class="text-sm text-gray-600 mb-2">{{formatAddress(selectedItem)}}</p>
              </div>
              <a [href]="selectedItem?.location" rel="noopener noreferrer" class="w-[180px] px-4 py-2 box-shadow-ff gap-2 rounded-full flex items-center justify-center hover:bg-gray-50 text-black hover:text-blue-500 transition" target="_blank"><i class="fas fa-directions"></i> Get Directions</a>
            </div>
          </div>
        </div>

        <div class="bg-[#F7F6F6] rounded-2xl p-6 mb-8">
            <p class="text-[14px] mb-8 flex items-center gap-2 text-black font-semibold"> 
                <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
                Property Specifications
            </p>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-6 gap-x-4">
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/landarea.svg" alt="" /> Land Area </p>
                    <p class="text-[14px] font-semibold pl-6"> {{ selectedItem?.landArea | numberFormat }} sqft. </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/superbuildup.svg" alt="" />Super Built-up Area </p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.superBuiltUpArea | numberFormat }} sqft. </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/possession.svg" alt="" /> Possession Status</p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.possession}} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/possession.svg" alt="" /> Possession Year</p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.possessionYear }} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/structure.svg" alt="" /> Structure </p>
                    <p class="text-[14px] font-semibold pl-8"> {{ formatBuildingStr(selectedItem?.structure) }} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/face.svg" alt="" /> Facing </p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.facing }} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/border_inner.svg" alt="" /> Property Type </p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.propertyType }}  - <span *ngFor="let item of selectedItem?.price"> {{item.propertyStructureType}}</span></p>
                </div>
                <!-- <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/bedroom.svg" alt="" /> Property Type </p>
                    <p class="text-[14px] font-semibold pl-6"> {{selectedItem? | json}}</p>
                </div>  -->
                <div>
                  <p class="text-[14px] flex gap-2 text-black font-normal mb-1"><img class="w-5 h-5" src="assets/img/bedroom.svg" alt="" /> Age of Property</p>
                  <p class="text-[14px] font-semibold pl-8">{{ selectedItem?.ageOfProperty}}</p>
                </div>
                <!-- <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/batthroom.svg" alt="" /> Room Counts </p>
                    <p class="text-[14px] font-semibold pl-6 gap-2" ><span *ngFor="let item of selectedItem?.price">{{ item.bhkType }} BHK :  {{ item.areaInSq }} sqft.</span></p>
                </div> -->
                <!-- <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/batthroom.svg" alt="" /> Total Area </p>
                    <p class="text-[14px] font-semibold pl-6"> {{ selectedItem?.totalArea }} </p>
                </div> -->
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/furniture.svg" alt="" /> Furnishing </p>
                    <p class="text-[14px] font-semibold pl-8"> {{ selectedItem?.furnishing }} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/price.svg" alt="" /> Avg. price </p>
                    <p class="text-[14px] font-semibold pl-8" *ngIf="selectedItem?.price?.length">₹ {{ selectedItem?.price[0].averagePrice | numberFormat }}/sqft </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/rera.svg" alt="" /> Rera </p>
                    <p class="text-[14px] font-semibold pl-8 break-words max-w-[150px] sm:max-w-[200px] underline"> {{ selectedItem?.reraNumber }} </p>
                </div>
                <div>
                    <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/parking.svg" alt="" /> Parking Availability</p>
                    <p class="text-[14px] font-semibold pl-8" > {{ selectedItem?.parking}} {{ selectedItem?.parkingCapacity }} </p>
                </div>
            </div>
        
            <div class="mt-8 pt-6 border-t border-gray-200">
                <p class="text-[14px] flex items-center gap-2 text-black font-semibold mb-4"> 
                    <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                    Additional Rooms 
                </p>
                
                <div class="flex flex-wrap gap-3 pl-7">
                    @for (room of selectedItem?.additionalRooms; track room) {
                    <div class="flex items-center gap-3 px-4 py-2 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all duration-300 group cursor-default">
                        <div class="w-6 h-6 rounded text-black flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                            <i [class]="getRoomIcon(room)" class="text-[10px]"></i>
                        </div>
                        <span class="text-[13px] font-semibold text-gray-700 group-hover:text-indigo-900">
                            {{ room }}
                        </span>
                    </div>
                    }
                </div>
                
            </div>
            <div class="mt-8 pt-6 border-t border-gray-200">
                <p class="text-[14px] flex items-center gap-2 text-black font-semibold mb-4"> 
                    <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                    Amenities 
                </p>
                
                <div class="flex flex-wrap gap-3 pl-7">
                    @for (amenity of getVisibleAmenities(selectedItem?.amenities); track amenity.key) {

                        <div class="flex items-center gap-3 px-4 py-2 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all duration-300 group cursor-default">
                            <div class="w-6 h-6 rounded text-black flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path [attr.d]="amenity.icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <span class="text-xs font-semibold text-gray-700 group-hover:text-indigo-700">
                                {{ amenity.label }}
                            </span>
                        </div>

                    } @empty {
                        <p class="text-sm text-gray-400 italic">No amenities available for this property.</p>
                    }
                </div>
            </div>
              
            <!-- <div class="mt-8 pt-6 border-t border-gray-200">
                <p class="text-[14px] flex items-center gap-2 text-black font-semibold mb-4"> 
                    <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12V8a2 2 0 00-2-2H6a2 2 0 00-2 2v4m16 0a2 2 0 012 2v3a2 2 0 01-2 2H4a2 2 0 01-2-2v-3a2 2 0 012-2m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 12H4" />
                    </svg>
                    Furnishing 
                </p>
                <div class="flex items-center gap-3 px-4 py-2 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all duration-300 group cursor-default">
                    <div class="w-6 h-6 rounded text-black flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 20h16M4 17h16M7 14h10M9 4h6l2 7H7l2-7z" />
                        </svg>
                    </div>
                    <span class="text-[13px] font-semibold text-gray-700 group-hover:text-indigo-900">
                        {{selectedItem?.furnishing}}
                    </span>
                </div>
                
            </div> -->
        </div>
        
        <!-- <div class="bg-white border border-gray-200 mb-10 rounded-2xl p-6 mb-10">
            <h3 class="font-bold text-sm mb-4">Floor plan</h3>
            <app-floor-plan-viewer></app-floor-plan-viewer>
        </div> -->
      </div>

      }
      @if (activeTab === 'intelligence' || activeTab === 'investment') {
        <app-premium-feature-lock [layout]="activeTab" />
      }
      @if (activeTab === 'location' && isUnlocked) {
        <app-property-location [selectedItem]="selectedItem" />
      }
      </section>


    </div>
  </div>
</main>

<main class="flex-1 overflow-y-auto bg-white" *ngIf="!selectedItem">
    <div class="flex min-h-full flex-col items-center justify-center rounded-xl bg-white p-8 text-center shadow-sm">
  
        <div class="flex mb-6 animate-bounce-slow">
          <div class="flex h-32 w-32 items-center justify-center rounded-full bg-blue-50">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <div class="absolute -bottom-2 -right-2 rounded-full bg-white p-2 shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      
        <div class="animate-fade-in-up">
          <h3 class="mb-2 text-2xl font-bold text-gray-800">No Properties Found</h3>
          <p class="mb-8 max-w-xs text-gray-500">
            We couldn't find any properties matching your current filters. Try adjusting your budget or location.
          </p>
          
          <!-- <button 
            onclick="resetFilters()"
            class="rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white transition-all hover:bg-blue-700 hover:shadow-lg active:scale-95">
            Clear All Filters
          </button> -->
        </div>
      </div>
</main>


<!-- Success Modal -->
<div *ngIf="showSuccessModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="closeSuccessModal()"></div>
    <!-- Modal Card -->
    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 animate-scale-in">
        <!-- Icon -->
        <div class="flex justify-center mb-4">
            <div class="w-12 h-12 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xl font-bold"> ✓ </div>
        </div>
        <!-- Message -->
        <p class="text-center text-gray-800 font-medium leading-relaxed"> Thank you for your interest. An advisor will contact you soon on your registered mobile number. </p>
        <!-- Action -->
        <div class="mt-6 flex justify-center">
            <button (click)="closeSuccessModal()" class="px-6 py-2.5 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 transition"> Okay </button>
        </div>
    </div>
</div>


@if (isUpgradeModalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">

    <!-- Modal Card -->
    <div class="relative w-full max-w-lg bg-white rounded-3xl shadow-2xl p-10 text-center animate-fadeIn">

      <!-- Close -->
      <button 
        (click)="closeUpgradeModal()"
        class="absolute top-4 right-4 text-gray-400 hover:text-black transition">
        ✕
      </button>

      <!-- Icon Badge -->
      <div class="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center shadow-inner">
        <svg class="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 11V7a4 4 0 10-8 0v4M5 11h14a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2z"/>
        </svg>
      </div>

      <!-- Heading -->
      <h2 class="text-3xl font-bold text-gray-900 mb-3">
        Unlock More Property Insights
      </h2>

      <p class="text-gray-600 mb-8 leading-relaxed">
        You've explored your {{ maxFreeViews }} free properties. Upgrade to Premium to access unlimited property details, Circled Intelligence (CI) and investment insights.
      </p>

      <!-- Benefits -->
      <div class="text-sm text-gray-600 space-y-2 mb-8">
        <div class="flex items-center justify-center gap-2">
          <span class="w-2 h-2 bg-indigo-500 rounded-full"></span>
          Access to premium listings
        </div>
        <div class="flex items-center justify-center gap-2">
          <span class="w-2 h-2 bg-indigo-500 rounded-full"></span>
          Direct advisor connect
        </div>
        <div class="flex items-center justify-center gap-2">
          <span class="w-2 h-2 bg-indigo-500 rounded-full"></span>
          Early access to new launches
        </div>
      </div>

      <!-- CTA -->
      <button
        routerLink="/payment"
        class="w-full py-4 rounded-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-lg shadow-lg hover:scale-[1.02] transition-transform duration-200">
        Unlock Full Details
      </button>

      <button type="button" (click)="closeUpgradeModal()" class="mt-4 text-sm text-gray-600">Continue Exploring</button>
      <p class="text-xs text-gray-400 mt-4">
        Secure checkout • Instant activation
      </p>

    </div>

  </div>
}
}
